import React from "react"
import { Link } from "gatsby"
import _ from 'lodash'
import ReactHtmlParser from 'react-html-parser'
import shortid from 'shortid'
import * as utils from './common/utils'
import { breakpoint } from './common/utils'
import styles from './Header.module.scss'
// components
import Logo from '../images/svg/logo_happysunny.svg'
import Instagram from '../images/svg/icon_instagram.svg'
import Twitter from '../images/svg/icon_twitter.svg'
import Facebook from '../images/svg/icon_facebook.svg'
import Youtube from '../images/svg/icon_youtube.svg'

const Icon = {
    instagram: <Instagram />,
    twitter : <Twitter />,
    facebook: <Facebook />,
    youtube: <Youtube />
}

class Header extends React.Component {
    constructor() {
        super();
        this.state = {
            windowWidth: 0,
            scrollTop: 0,
            navOpen: false,
        }
    }

    componentDidMount() {
        const { windowWidth } = utils.init();
        this.setState ({
            windowWidth: windowWidth,
        });

        window.addEventListener('resize', _.debounce(() => {
            const { windowWidth } = utils.init();
            this.setState ({
                windowWidth: windowWidth,
            });
            this.handleViewHeight();
        }, 1000));

        window.addEventListener('scroll', _.debounce(() => {
            this.handleScroll();
        }, 1000))

    }

    handleScroll() {
        const scrollTop = Math.max(
            window.pageYOffset,
            document.documentElement.scrollTop,
            document.body.scrollTop
        );

        this.setState({
            scrollTop: scrollTop,
        });
    }

    handleMobileNav() {
        const navOpen = !this.state.navOpen;
        this.setState({
            navOpen: navOpen,
        });
    }

    closeMobileNav() {
        this.setState({
            navOpen: false,
        });
    }

    handleViewHeight() {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    }

    render() {
        const { siteTitle } = this.props;

        return (
            <header
                className={styles.wrapper}
            >
                <div className={styles.container}>
                    <div className={styles.logo}>
                        <h1 className="sr-only">{siteTitle}</h1>
                        <Logo />
                    </div>
                    {this.renderNav()}
                </div>
            </header>
        );
    }

    renderNav() {
        if (this.state.windowWidth >= breakpoint) {
            return (
                <>
                    {this.renderNavItems()}
                </>
            );
        } else {
            return (
                <>
                    <div className={`${styles.mobileNavWrapper} ${this.state.navOpen ? styles.isActive : ''}`}>
                        <div className={styles.mobileNavContainer}>
                            <div className={styles.mobileNavLogo}>
                                <Logo />
                            </div>
                            {this.renderNavItems()}
                        </div>
                    </div>
                    <div 
                        className={`${styles.burger} ${this.state.navOpen ? styles.isActive : ''}`}
                        onClick={() => this.handleMobileNav()}
                    >
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </>
            )
        }
    }

    renderNavItems() {
        const { pageMetadata } = this.props;
        const pages = pageMetadata.pages;
        const socials = pageMetadata.socials;

        return (
            <>
                <nav className={styles.nav}>
                    {pages.map(item => {
                        const ItemName = () => (
                            <>
                                {ReactHtmlParser(item.name)}
                                <span className={styles.navItemHover}>
                                    {item.name_ja}
                                </span>                            
                            </>
                        );

                        if ( item.link_type === 'scroll' ) {
                            const moveTo = () => utils.moveto(item.pathname);

                            return (
                                <div 
                                    className={styles.navItem}
                                    onClick={moveTo}
                                >
                                    <ItemName />
                                </div>
                            );
                        } else if ( item.link_type === 'link' ) {
                            return (
                                <Link 
                                    key={shortid.generate()}
                                    to={`/${item.pathname}`}
                                    className={styles.navItem}
                                    activeClassName={styles.isActive}
                                    title={item.name_ja}
                                >
                                    <ItemName />
                                </Link>
                            );
                        } else if ( item.link_type === 'external' ) {
                            return (
                                <a 
                                    key={shortid.generate()}
                                    href={item.pathname} 
                                    className={styles.navItem}
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    title={item.name_ja}
                                >
                                    <ItemName />
                                </a>
                            );
                        }
                    })}
                </nav>
                <div className={styles.social}>
                    {socials.map(item => {
                        const IconSns = () => (Icon[item.icon_type]);

                        return (
                            <a 
                                key={shortid.generate()}
                                href={item.url}
                                className={`${styles.socialItem} ${styles[item.icon_type]}`}
                                target="_blank" 
                                rel="noopener noreferrer"
                                title={item.title}
                            >
                                <IconSns />
                            </a>
                        )
                    })}
                </div>
            </>
        );
    }
}

export default Header;
